export default "__VITE_ASSET__jMSpzRlE__"